import { AddEntityDialog } from "@/components/common/add-entity-dialog";
import { addCategorySchema } from "@/zod-schemas/services/add-category-schema";
import { getCategoryFormValues } from "@/default-form-values/services/default-category-form-values";
import { useCreateCategory } from "@/hooks/services/use-categories";

export function AddCategory() {
  const createCategory = useCreateCategory();

  return (
    <AddEntityDialog
      entityName="Category"
      schema={addCategorySchema}
      defaultValues={getCategoryFormValues}
      onCreate={async (data) => {
        await createCategory.mutateAsync({
          name: data.name,
        });
      }}
    />
  );
}
